export const styles = {
  tableCeil: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #F3F4F9',
  },

  name: {
    width: '150px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'start',
    padding: '14px 16px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
    position: 'relative',
  },

  nameWrapper: {
    position: 'absolute',
    left: '16px',
    right: '16px',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    'line-clamp': '1',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-all',
    overflow: 'hidden',
    border: 'none',
    zIndex: 1,
    background: 'white',
  },

  lagDays: {
    width: '94px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'start',
    padding: '14px 16px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
  },

  date: {
    width: '120px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'start',
    padding: '14px 16px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
    position: 'relative',
  },

  actions: {
    width: '80px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'start',
    padding: '14px 16px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
  },

  controller: {
    border: 'none !important',
    padding: '0 !important',
    height: '20px',

    '& input': {
      border: 'none',
      height: '20px',
      padding: '0',
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#23252F',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
      borderRadius: '0 !important',
    },

    '& .MuiOutlinedInput-root': {
      height: '20px',
      background: '#fff !important',
    },

    '& .MuiFormControl-root': {
      border: 'none',
      padding: '0 ',
      height: '20px',

      '& .MuiOutlinedInput-root': {
        height: '20px',
      },
    },
  },

  controllerHidden: {
    border: 'none !important',
    padding: '0 !important',
    height: '20px',
    opacity: 0,

    '& input': {
      border: 'none',
      height: '20px',
      padding: '0',
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#23252F',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
      borderRadius: '0 !important',
    },

    '& .MuiOutlinedInput-root': {
      height: '20px',
      background: '#fff !important',
    },

    '& .MuiFormControl-root': {
      border: 'none',
      padding: '0 ',
      height: '20px',

      '& .MuiOutlinedInput-root': {
        height: '20px',
      },
    },
  },

  actionsButton: {
    width: '100%',
    padding: '0',
    minWidth: 'auto',
    background: 'none',
    backgroundColor: 'none',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .MuiButton-startIcon': {
      marginRight: '0',
    },

    '&:hover': { background: 'none', backgroundColor: 'none', border: 'none' },
  },
};
